import { FC } from "react";
import { LinkCard } from "@/components/LinkCard";
import { Sparkles } from "lucide-react";

interface LinksDisplayProps {
  links: any[];
}

export const LinksDisplay: FC<LinksDisplayProps> = ({ links }) => {
  if (links.length === 0) return null;

  return (
    <section className="py-6 container mx-auto px-4">
      <div className="flex items-center justify-center space-x-2 mb-3">
        <Sparkles className="w-6 h-6 text-green-500" />
        <h2 className="text-2xl font-black bg-gradient-to-r from-green-600 to-green-400 bg-clip-text text-transparent">
          Link Produk Anda
        </h2>
        <Sparkles className="w-6 h-6 text-green-500" />
      </div>
      <div className="grid gap-3 max-w-xl mx-auto">
        {links.map((link, index) => (
          <div
            key={link.id}
            className="animate-fade-up animate-once"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <LinkCard
              title={link.title}
              url={link.url}
              whatsapp_number={link.whatsapp_number}
              message_template={link.message_template}
              description={link.description}
            />
          </div>
        ))}
      </div>
    </section>
  );
};